webpackJsonp([72569911114162],{

/***/ 1945:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ProcessorPayment","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"amount","type":{"kind":"SCALAR","name":"Decimal","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"datetime","type":{"kind":"SCALAR","name":"DateTime","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"type","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-processor-payment-0b15012b02e828ed8f22.js